/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Three_PlInputs */

const en_reference_field_three_pl = /** @type {(inputs: Reference_Field_Three_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3PL`)
};

/**
* | output |
* | --- |
* | "3PL" |
*
* @param {Reference_Field_Three_PlInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_three_pl = /** @type {((inputs?: Reference_Field_Three_PlInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Three_PlInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_three_pl(inputs)
});